export default __webpack_public_path__ + "static/media/books.8ca90014.jpg";